import * as React from "react";
const SvgSearch = props => <svg xmlns="http://www.w3.org/2000/svg" width={19} height={18} viewBox="0 0 19 18" {...props}><path fillRule="evenodd" d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-1.43 5.74a8 8 0 1 1 .67-.74l4.05 3.77-.73.68z" clipRule="evenodd" /></svg>;
export default SvgSearch;